
const digest = '0aba421c1e2f6b62adad8d2f040a0bf8bff1f509d56cf3aaebe94d6930a927eb';
const classes = {"wrapper":"_wrapper_16y9k_1","content":"_content_16y9k_5","title":"_title_16y9k_11","items":"_items_16y9k_15"};
const css = `._wrapper_16y9k_1 {
  display: flex;
  flex-direction: column;
}
._wrapper_16y9k_1 ._content_16y9k_5 {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 24px;
}
._wrapper_16y9k_1 ._content_16y9k_5 ._title_16y9k_11 {
  font-weight: 600;
  font-size: 18px;
}
._wrapper_16y9k_1 ._content_16y9k_5 ._items_16y9k_15 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  